import { Helmet } from "react-helmet-async"
import { InstructorList } from "widgets/instructor"
import { Container, createStyles } from "@mantine/core"
import React from "react"
import { PageTitle } from "../../shared/ui/PageTitle"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  container: {
    paddingTop: "4rem",
    paddingBottom: "4rem",

    [theme.fn.smallerThan("md")]: {
      paddingTop: "3rem",
      paddingBottom: "3rem",
    },

    [theme.fn.smallerThan("xs")]: {
      paddingTop: "1.5rem",
      paddingBottom: "1.5rem",
    },
  },
}))

// ----------------------------------------------------------------------

export function InstructorListPage(): React.JSX.Element {
  const { classes } = useStyles()
  const url = new URL(window.location.href)

  return (
    <>
      <Helmet>
        <title>BodyCoach - преподаватели</title>
        <meta property="og:title" content="BodyCoach - преподаватели"/>

        <meta name="description"
              content="Преподаватели образовательной платформы Body Coach"/>
        <meta property="og:description"
              content="Преподаватели образовательной платформы Body Coach"/>

        <meta property="og:url" content={url.href}/>
        <link rel="canonical" href={url.href}/>
        <meta property="og:site_name" content={url.host}/>
        <meta name="robots" content="index, follow"/>

        <meta name="keywords"
              content="фитнес-тренер,фитнес-обучения,образовательный центр,образование,преподаватели боди коуч, учителя боди коуч, body coach преподаватели"/>
      </Helmet>

      <Container size="lg" className={classes.container}>
      <PageTitle title="Наши преподаватели"/>

        <InstructorList/>
      </Container>
    </>
  )
}
